//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const MspExternalReferenceRepository: FeatureFlag = {"Id":"MspExternalReferenceRepository","Label":"Support MSP external references","Impact":"Legacy. To be removed. Don't change","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
